<script setup>
import TvSection from '~/components/tv/TvSection.vue';
import {tvCompactTeamName, tvWhen} from '~/utils/tvDisplay';

// Always on screen: the next matches with an agreed time
const props = defineProps({
  matches: {type: Array, default: () => []},
  // Coming up keeps a fixed size; results take the rest of the sidebar
  limit: {type: Number, default: 4},
});

const shown = computed(() => props.matches.slice(0, props.limit));
</script>

<template>
  <tv-section icon="mdi-calendar-clock" title="Coming up">
    <div v-if="shown.length" class="tv-up-list">
      <div v-for="match in shown" :key="match.fixtureId" class="tv-up-row">
        <span class="tv-up-when">{{ tvWhen(match.scheduledAt) }}</span>
        <span class="tv-up-teams">{{ tvCompactTeamName(match.homeTeamName) }} <span class="tv-up-v">v</span> {{ tvCompactTeamName(match.awayTeamName) }}</span>
        <span v-if="match.playingAreaName" class="tv-up-court">{{ match.playingAreaName }}</span>
      </div>
    </div>
    <p v-else class="tv-up-empty">No matches booked in the next week.</p>
  </tv-section>
</template>

<style scoped lang="scss">
.tv-up-row {
  display: grid;
  grid-template-columns: 190px 1fr auto;
  align-items: center;
  gap: 16px;
  height: 52px;
  border-bottom: 1px solid var(--tv-line);

  &:last-child {
    border-bottom: 0;
  }
}

.tv-up-when {
  font-family: var(--tv-display);
  font-weight: 700;
  font-size: 28px;
  color: var(--tv-accent-text);
  white-space: nowrap;
}

.tv-up-teams {
  font-size: 21px;
  letter-spacing: -0.3px;
  color: var(--tv-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tv-up-v {
  color: var(--tv-muted);
  padding: 0 4px;
}

.tv-up-court {
  font-size: 20px;
  color: var(--tv-muted);
  white-space: nowrap;
}

.tv-up-empty {
  margin: 0;
  padding: 16px 12px;
  font-size: 22px;
  color: var(--tv-muted);
}
</style>
